import React from 'react';
import { motion } from 'framer-motion';

/** The group chat, roughly forty-eight hours after everyone gets home. */
const messages = [{
  text: 'Who paid for the taxi?',
  side: 'left'
}, {
  text: "I'll send you the money later.",
  side: 'right'
}, {
  text: 'Why do I owe £63?',
  side: 'left'
}, {
  text: "Who hasn't paid yet?",
  side: 'right'
}, {
  text: 'I think we’re about even?',
  side: 'left'
}, {
  text: 'Someone do a spreadsheet 😅',
  side: 'right'
}];
export function ProblemSection() {
  return <section className="relative overflow-hidden bg-gray-950 py-20 text-white lg:py-28" data-id="element-260" data-mp="35h2azohkscdi">
      <div aria-hidden="true" className="absolute inset-0 bg-[radial-gradient(circle_at_25%_15%,rgba(249,226,52,0.07),transparent_55%)]" data-id="element-261" data-mp="3jglgsamwzbmn" />

      <div className="relative mx-auto max-w-7xl px-6 sm:px-8" data-id="element-262" data-mp="3ef5xoo4arf6w">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-263" data-mp="1p2u2gxtn43kv">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} data-id="element-264" data-mp="1k3r8c8f77hro">
            <h2 className="mb-5 text-3xl font-black leading-[1.1] tracking-tight md:text-4xl lg:text-5xl" data-id="element-265" data-mp="ocq0ewbunpzp">
              Group trips are fun.
              <br data-id="element-266" data-mp="x4i84z9hol0l" />
              <span className="text-kitty-yellow" data-id="element-267" data-mp="x51qui6yrdfo">
                The maths afterwards isn't.
              </span>
            </h2>
            <p className="max-w-md text-lg leading-relaxed text-gray-400" data-id="element-268" data-mp="122tjjeffn3kx">
              One person books everything. Someone else buys the drinks. Three
              weeks later nobody can remember who owes what, and asking feels
              worse than just letting it go.
            </p>
          </motion.div>

          <motion.ul initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.07
            }
          }
        }} className="space-y-3" data-id="element-269" data-mp="1g2l0no18x035">
            {messages.map(message => <motion.li key={message.text} variants={{
            hidden: {
              opacity: 0,
              y: 12
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.35,
                ease: [0.22, 1, 0.36, 1]
              }
            }
          }} className={message.side === 'right' ? 'flex justify-end' : 'flex justify-start'} data-id="element-270" data-mp="k1z79kssgfv1">
                <span className={`max-w-[85%] rounded-2xl px-5 py-3.5 text-base font-medium sm:text-lg ${message.side === 'right' ? 'rounded-br-md bg-kitty-yellow text-kitty-dark' : 'rounded-bl-md bg-white/[0.08] text-gray-100'}`} data-id="element-271" data-mp="1hoeiw5yjajao">
                  {message.text}
                </span>
              </motion.li>)}
          </motion.ul>
        </div>
      </div>
    </section>;
}